import { AlertModalType } from "shared/components/alertModal/type";
import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "shared/context/auth";
import { useCopies } from "shared/hooks/useCopies";
import { ApiRegistrationParticipantForManagement } from "shared/types/ApiRegistrationParticipantForManagement";
import { useRevokeOrgAdmin } from "../../dataloader";
import ApiRemoveOrgAdminRequest from "shared/types/ApiRemoveOrgAdminRequest";

export default function useAssignmentCellService() {
  const { userDetail } = useAuth();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const copies = useCopies();
  const [alertConfig, setAlertConfig] = React.useState<AlertModalType | null>(null);

  const { mutateAsync: revokeOrgAdmin } = useRevokeOrgAdmin({ regParticipantId: userDetail?.id });

  const nominateOrgAdminHandler = React.useCallback(
    (registrationParticipantId: string) => {
      navigate({
        pathname: registrationParticipantId,
        search: searchParams.toString()
      });
    },
    [navigate, searchParams]
  );

  const revokeOrgAdminHandler = React.useCallback(
    (registrationParticipant: ApiRegistrationParticipantForManagement) => {
      setAlertConfig({
        message: (
          <span
            dangerouslySetInnerHTML={{
              __html: copies.get("org.admin.revoke.confirm.message", {
                0: `${registrationParticipant.firstName} ${registrationParticipant.lastName}`
              })
            }}
          />
        ),
        handleConfirm: async () => {
          try {
            const reqObj: ApiRemoveOrgAdminRequest = {
              initiatorRegistrationParticipantId: userDetail?.id as string,
              registrationParticipantId: registrationParticipant.id,
              uiVersion: registrationParticipant.uiVersion
            };
            await revokeOrgAdmin(reqObj);
          } catch (err) {}
          setAlertConfig(null);
        },
        handleClose: () => {
          setAlertConfig(null);
        }
      });
    },
    [copies, revokeOrgAdmin, userDetail?.id]
  );

  return {
    alertConfig,
    nominateOrgAdminHandler,
    revokeOrgAdminHandler
  };
}
